export class ImportDocuments {
}

export class InsertUpdateImportDocumnets {
    importCompanyModel = new ImportCompanyModel();
    importCodeCrosswalkModel = new ImportCodeCrosswalkModel();
    importModel = new importModel();
    templateData = new TemplateData();
    mappingTemplateList=[];
    sourcingTemplateList=[];
    tempTemplateMappingColumns='';
    isVendor:boolean = false;
}

export class ImportCompanyModel {
    file: string='';
    salesPersonId: string='';
    altSalesPersonId: string='';
    buyersId: string='';
    mappingTemplateId: string='';
}

export class importModel {
    file: string='';
    salesPersonId: string='';
    companyId: string | null = '';
    contactId: string='';
    mappingTemplateId: string='';
}

export class ImportCodeCrosswalkModel {
    file: string='';
    mappingTemplateId: string='';
}

export class TemplateData {
    id: string='';
    fileName:string='';
    sourceId: number=1;
    templateName: string='';
    templateDescription: string='';
    isTemplateCreate: boolean=false;
    templateMappingColumns: TemplateMappingColumns[] = [];
}

export class TemplateMappingColumns {
    id: string='';
    templateId: string='';
    map:[]=[]
    mappedColumn: string='';
    systemColumn: string='';
    status: boolean;
    isRequired: boolean=false;
}



export class ImportCodeCrosswalkData{
    codeCrosswalkData: CodeCrosswalkData[]
    importError: ImportError[]
    duplicateCodeCrosswalk: DuplicateCodeCrosswalk[]
    templateId: string=''
}

export class CodeCrosswalkData {
    id: string=''
    createdBy: string=''
    createdAt: string=''
    updatedBy: string=''
    updatedAt: string=''
    isDeleted: boolean
    deletedBy: string=''
    deletedAt: string=''
    externalId: string=''
    rowNumber: number
    isValid: boolean
    templateId: string=''
    sic: string=''
    sicDescription: string=''
    naics: string=''
    naicsDescription: string=''
    naicsYear: string='';
    industry: string='';
  }

  export class DuplicateCodeCrosswalk {
    type: string='';
    sic: string='';
    naics: string='';
    industry: string='';
    action: boolean;
    rowNo: number;
  }


export class ImportCompanyCommand {
    companyData: CompanyData[]=[] ;
    importError: ImportError[]=[] ;
    duplicateCompanies:DuplicateCompanies[]=[];
    templateId: string='';
    isVendor:boolean = false;
}

export class CompanyData {
    id: string='';
    createdBy: string='';
    createdAt: string='';
    updatedBy: string='';
    updatedAt: string='';
    isDeleted: boolean
    deletedBy: string='';
    deletedAt: string='';
    externalId: string='';
    rowNumber: number=0;
    company: string='';
    stage: string='';
    phone: string='';
    salesperson: string='';
    email: string='';
    type: string='';
    dateContacted: string='';
    companyRating: string='';
    active: string='';
    fax: string='';
    website: string='';
    employees: string='';
    timezone: string='';
    industry: string='';
    sic: string='';
    naics: string='';
    country: string='';
    doNotCall: string='';
    revenue: string='';
    alternateSalesperson: string='';
    recentNotes: string='';
    accountNumber: string='';
    currency: string='';
    sourcingEmail: string='';
    accountingContact: string='';
    state: string='';
    isValid: boolean=false;
    templateId: string='';
  }

  
export class ImportError {
    companyName: string='';
    errorField: string='';
    errorData: string='';
    correctField: string='';
    errorMessage: string='';
    status: boolean=false;
    rowNumber: number;
  }  

export class DuplicateCompanies {
    type: string
    companyName: string
    phoneNumber: string
    address: string
    action: boolean
    rowNo: number
  }

  export class ImportBOMCommand {
    data: BOMData[] = [];
    importError: ImportError[] = [];
    duplicatePotential: DuplicateBOM[] = [];
    templateId: string = '';
  }
  
  export class DuplicateBOM {
    type: string;
    companyName: string;
    mpn: string;
    mfr: string;
    action: boolean;
    rowNo: number;
  }

export class BOMData {
  id: string='';
  createdBy: string='';
  createdAt: string='';
  updatedBy: string='';
  updatedAt: string='';
  isDeleted: boolean=false;
  deletedBy: string='';
  deletedAt: string='';
  externalId: string='';
  rowNumber: number=0;
  isValid: boolean=false;
  templateId: string='';
  company: string='';
  contact: string='';
  salesPerson: string='';
  requirementSource: string='';
  customerNotes: string='';
  customerRFQ: string='';
  priority: string='';
  isInHouseRequirement: boolean=false;
  mpn: string='';
  mfr: string='';
  qty: number=0;
  dateCodeYear: string='';
  dateCodeWeek: string='';
  customerPN: string='';
  nsn: string='';
  condition: string='';
  itemPkg: string='';
  description: string='';
  revision: string='';
  roHS: string='';
  roHSId: string='';
  coo: string='';
  testing: string='';
  customerTargetPrice: number=0;
  currency: string='';
  exchangeRate: string='';
  convertedTargetPrice: number=0;
  targetBuyPrice: number=0;
  needDate: string='';
  lotCode: string='';
  categoryGroup: string='';
  parentCategory: string='';
  category: string='';
  subCategory: string='';
  spq: string='';
  moq: string='';
  hts: string='';
  scheduleB: string='';
  eccn: string='';
  tempRange: string='';
  partStatus: string='';
  isProjectApproved: boolean=false;
  estStartDate: string='';
  bidDeadline: string='';
  endCustomer: string='';
  projectName: string='';
  closeProbability: number=0;
  application: string='';
  opportunityNotes: string='';
  opportunityTypeId: number=0;
  manufacturerCOC: boolean=false;
  companyCOC: boolean=false;
  requiredImages: boolean=false;
  requiredInspectionReport: boolean=false;
  additionalQuantity: number=0;
  requirementNumber: string='';
}
  // constants.ts
export const CROSSWALK_REQUIRED_VALUES = ["SIC Code", "SIC Description", "NAICS Code", "NAICS Description", "NAICS Year", "Industry"];
export const COMPANY_REQUIRED_VALUES = ["Company Name", "Sales Stage", "Company Type", "Company Country", "Address Name", "Address Type", "Address Country", "Contact First Name", "Contact Last Name"];
export const VENDOR_REQUIRED_VALUES = ['Vendor Name', 'Country', 'Type', 'Contact First Name', 'Contact Last Name', 'Address Type', 'Address Name', 'Address Country'];
export const BOM_REQUIRED_FIELDS = ["MPN", "MFR","Date Code Year","Date Code Week","Qty","RoHS","Condition","Testing","Need Date", "Opportunity Type"];

export enum ImportDocumentStep {
  Upload = 'Upload',
  Map = 'Map',
  Preview = 'Preview',
  Errors = 'Errors',
  Summary = 'Summary'
}

export const IMPORT_DOCUMENT_STEPS: string[] = [
  ImportDocumentStep.Upload,
  ImportDocumentStep.Map,
  ImportDocumentStep.Preview,
  ImportDocumentStep.Errors,
  ImportDocumentStep.Summary
];


  